export default function DialogButton({ isCancel, children, ...props }) {
  let classes = `${isCancel ? "bg-white text-gray8b border-[1px] border-gray-200" : "bg-primary-500 text-white font-semibold"} rounded-[10px]  w-full h-[48px] `;
  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
}
